import gql from 'graphql-tag'

export default {
  CREATE_BOARD: gql`
    mutation createBoard($projectUid: UUID!, $input: CreateBoardInput!) {
      createBoard(projectUid: $projectUid, input: $input) {
        status
        message
        data {
          uuid
          name
          updatedAt
          createdAt
          statuses {
            id
            key
            name
            color
            position
            isFinal
          }
        }
      }
    }
  `,

  UPDATE_BOARD: gql`
    mutation updateBoard($boardUid: UUID!, $projectUid: UUID!, $input: UpdateBoardInput!) {
      updateBoard(projectUid: $projectUid, boardUid: $boardUid, input: $input) {
        status
        message
        data {
          uuid
          name
          order
          updatedAt
        }
      }
    }
  `,

  DELETE_BOARD: gql`
    mutation deleteBoard($projectUid: UUID!, $boardUid: UUID!) {
      deleteBoard(projectUid: $projectUid, boardUid: $boardUid) {
        status
        message
        data {
          uuid
        }
      }
    }
  `,

  ADD_BOARD_MEMBER: gql`
    mutation addBoardMember($projectUid: UUID!, $boardUid: UUID!, $memberUid: UUID!) {
      addBoardMember(projectUid: $projectUid, boardUid: $boardUid, memberUid: $memberUid) {
        status
        message
        data {
          uuid
          members {
            data {
              uuid
              name
              email
              avatar
            }
          }
        }
      }
    }
  `,

  REMOVE_BOARD_MEMBER: gql`
    mutation removeBoardMember($projectUid: UUID!,$boardUid: UUID!, $memberUid: UUID!) {
      removeBoardMember(projectUid: $projectUid, boardUid: $boardUid, memberUid: $memberUid) {
        status
        message
        data {
          uuid
          members {
            data {
              uuid
              name
              email
              avatar
            }
          }
        }
      }
    }
  `,

  // Task Status mutations
  CREATE_TASK_STATUS: gql`
    mutation createTaskStatus($projectUid: UUID!, $boardUid: UUID!, $input: CreateTaskStatusInput!) {
      createTaskStatus(projectUid: $projectUid, boardUid: $boardUid, input: $input) {
        message
        status
        data {
          id
          key
          name
          color
          position
          isFinal
        }
      }
    }
  `,

  UPDATE_TASK_STATUS: gql`
    mutation updateTaskStatus($projectUid: UUID!, $boardUid: UUID!, $input: UpdateTaskStatusInput!) {
      updateTaskStatus(projectUid: $projectUid, boardUid: $boardUid, input: $input) {
        message
        status
        data {
          id
          key
          name
          color
          position
          isFinal
        }
      }
    }
  `,

  DELETE_TASK_STATUS: gql`
    mutation deleteTaskStatus($id: ID!, $reassignStatusId: ID) {
      deleteTaskStatus(id: $id, reassignStatusId: $reassignStatusId) {
        message
        status
      }
    }
  `,

  // Task mutations
  CREATE_TASK: gql`
    mutation createTask($projectUid: UUID!, $boardUid: UUID!, $input: CreateTaskInput!) {
      createTask(projectUid: $projectUid, boardUid: $boardUid, input: $input) {
        message
        status
        data {
          uuid
          title
          description
          status {
            id
            key
            name
            color
            isFinal
          }
          assignee {
            uuid
            name
            avatar
          }
          priority
          dueDate
          timeEstimate
          createdAt
        }
      }
    }
  `,

  UPDATE_TASK: gql`
    mutation updateTask($uuid: UUID!, $input: UpdateTaskInput!) {
      updateTask(uuid: $uuid, input: $input) {
        message
        status
        data {
          uuid
          title
          description
          priority
          status {
            id
            key
            name
            color
            isFinal
          }
          assignee {
            uuid
            name
            avatar
          }
          dueDate
          timeEstimate
          updatedAt
        }
      }
    }
  `,

  MOVE_TASK: gql`
    mutation moveTask($taskUid: UUID!, $statusId: ID!) {
      moveTask(taskUid: $taskUid, statusId: $statusId) {
        message
        status
        data {
          uuid
          title
          status {
            id
            key
            name
            color
            isFinal
          }
        }
      }
    }
  `,

  DELETE_TASK: gql`
    mutation deleteTask($uuid: UUID!) {
      deleteTask(uuid: $uuid) {
        message
        status
        data {
          uuid
        }
      }
    }
  `,
  UPLOAD_TASK_ASSET: gql`
    mutation uploadTaskAsset($input: UploadTaskAssetInput!) {
      uploadTaskAsset(input: $input) {
        message,
        status,
        data {
          uuid,
          url,
        }
      }
    }
  `,
  DELETE_TASK_ASSET: gql`
    mutation deleteTaskAsset($uuid: UUID!) {
      deleteTaskAsset(uuid: $uuid) {
        message,
        status,
      }
    }
  `,
  ASSIGN_TASK: gql`
    mutation assignTask(
      $uuid: UUID!,
      $projectUid: UUID!,
      $assigneeUid: UUID,
    ) {
      assignTask(
        uuid: $uuid,
        projectUid: $projectUid,
        assigneeUid: $assigneeUid,
      ) {
        message,
        status,
      }
    }
  `,
  CREATE_BOARD_LABEL: gql`
    mutation createBoardLabel(
      $projectUid: UUID!,
      $boardUid: UUID!,
      $input: CreateBoardLabelInput!,
    ) {
      createBoardLabel(
        projectUid: $projectUid,
        boardUid: $boardUid,
        input: $input,
      ) {
        message,
        status,
      }
    }
  `,
  UPDATE_BOARD_LABEL: gql`
    mutation updateBoardLabel(
      $projectUid: UUID!,
      $boardUid: UUID!,
      $labelUid: UUID!,
      $input: UpdateBoardLabelInput!,
    ) {
      updateBoardLabel(
        projectUid: $projectUid,
        boardUid: $boardUid,
        labelUid: $labelUid,
        input: $input,
      ) {
        status,
        message,
      }
    }
  `,
  DELETE_BOARD_LABEL: gql`
    mutation deleteBoardLabel(
      $projectUid: UUID!,
      $boardUid: UUID!,
      $labelUid: UUID!,
    ) {
      deleteBoardLabel(
        projectUid: $projectUid,
        boardUid: $boardUid,
        labelUid: $labelUid,
      ) {
        status,
        message,
      }
    }
  `,
  CREATE_MILESTONE: gql`
    mutation createMilestone(
      $projectUid: UUID!,
      $boardUid: UUID!,
      $input: CreateMilestoneInput!,
    ) {
      createMilestone(
        projectUid: $projectUid,
        boardUid: $boardUid,
        input: $input,
      ) {
        status
        message
      }
    }
  `,
  UPDATE_MILESTONE: gql`
    mutation updateMilestone(
      $projectUid: UUID!,
      $boardUid: UUID!,
      $uuid: UUID!,
      $input: UpdateMilestoneInput!,
    ) {
      updateMilestone(
        projectUid: $projectUid,
        boardUid: $boardUid,
        uuid: $uuid,
        input: $input,
      ) {
        status
        message
      }
    }
  `,
  DELETE_MILESTONE: gql`
    mutation deleteMilestone(
      $projectUid: UUID!
      $boardUid: UUID!
      $uuid: UUID!
    ) {
      deleteMilestone(
        projectUid: $projectUid
        boardUid: $boardUid
        uuid: $uuid
      ) {
        status
        message
      }
    }
  `,
  ATTACH_TEMPORARY_ASSET: gql`
    mutation attachTemporaryAsset($input: AttachTemporaryAssetsInput!) {
      attachTemporaryAssets(input: $input) {
        status,
        message,
        data {
          url
          temporaryToken
        }
      }
    }
  `,
  ADD_TASK_COMMENT: gql`
    mutation addTaskComment(
      $taskUid: UUID!,
      $input: AddTaskCommentInput!,
    ) {
      addTaskComment(
        taskUid: $taskUid,
        input: $input,
      ) {
        status,
        message,
        data {
          uuid,
          content,
          createdAt,
          updatedAt,
          mentions,
          mentionedUsers {
            uuid,
            name,
            avatar,
          }
          author {
            uuid,
            name,
            avatar,
          }
        }
      }
    }
  `,
  UPDATE_TASK_COMMENT: gql`
    mutation updateTaskComment(
      $commentUid: UUID!,
      $content: String!,
    ) {
      updateTaskComment(
        commentUid: $commentUid,
        content: $content,
      ) {
        status,
        message,
      }
    }
  `,
  DELETE_TASK_COMMENT: gql`
    mutation deleteTaskComment(
      $commentUid: UUID!,
    ) {
      deleteTaskComment(
        commentUid: $commentUid,
      ) {
        status,
        message,
      }
    }
  `,
  ATTACH_TEMPORARY_COMMENT_ASSET: gql`
    mutation attachTemporaryCommentAsset($input: AttachTemporaryCommentAssetsInput!) {
      attachTemporaryCommentAssets(input: $input) {
        status,
        message,
        data {
          url
          temporaryToken
        }
      }
    }
  `,
  UPLOAD_COMMENT_ASSET: gql`
    mutation uploadCommentAsset($input: UploadCommentAssetInput!) {
      uploadCommentAsset(input: $input) {
        status,
        message,
        data {
          url
        }
      }
    }
  `,
}
